/**
 * お問い合わせフォーム（確認 → 送信）
 */
(function () {
  var FORM_ID = 'DreampieceContactForm';
  var PANEL_HIDDEN_CLASS = 'contact-page-panel--hidden';

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function getScrollTop(root) {
    var target = root.querySelector('.contact-page-head') || root;
    var header = document.querySelector('.section-header, .header-wrapper, header');
    var offset = header ? header.getBoundingClientRect().height + 16 : 16;

    return Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
  }

  function scrollContactToTop(root, behavior) {
    window.scrollTo({
      top: getScrollTop(root),
      behavior: behavior || 'smooth',
    });
  }

  function scrollContactToTopAfterPaint(root) {
    scrollContactToTop(root, 'auto');

    requestAnimationFrame(function () {
      scrollContactToTop(root, 'auto');
      requestAnimationFrame(function () {
        scrollContactToTop(root, 'smooth');
      });
    });

    window.setTimeout(function () {
      scrollContactToTop(root, 'auto');
    }, 120);
  }

  function initContact(root) {
    if (!root || root.dataset.dpContactReady === 'true') return;

    var successEl = root.querySelector('[data-dp-contact-success]');
    if (successEl) {
      root.dataset.dpContactReady = 'true';
      scrollContactToTopAfterPaint(root);
      if (typeof successEl.focus === 'function') {
        window.setTimeout(function () {
          successEl.focus({ preventScroll: true });
        }, 150);
      }
      return;
    }

    var form = root.querySelector('#' + FORM_ID) || root.querySelector('form.contact-page-form');
    if (!form) return;

    var editPanel = root.querySelector('[data-dp-contact-edit]');
    var confirmPanel = root.querySelector('[data-dp-contact-confirm]');
    var confirmBtn = root.querySelector('[data-dp-contact-confirm-btn]');
    var backBtn = root.querySelector('[data-dp-contact-back]');

    if (!editPanel || !confirmPanel || !confirmBtn || !backBtn) return;

    root.dataset.dpContactReady = 'true';

    var fields = {
      name: form.querySelector('[data-dp-contact-name]'),
      email: form.querySelector('[data-dp-contact-email]'),
      subject: form.querySelector('[data-dp-contact-subject]'),
      body: form.querySelector('[data-dp-contact-body]'),
    };

    var payload = {
      name: form.querySelector('[data-dp-field-name]'),
      email: form.querySelector('[data-dp-field-email]'),
      subject: form.querySelector('[data-dp-field-subject]'),
      body: form.querySelector('[data-dp-field-body]'),
    };

    var preview = {
      name: root.querySelector('[data-dp-contact-preview-name]'),
      email: root.querySelector('[data-dp-contact-preview-email]'),
      subject: root.querySelector('[data-dp-contact-preview-subject]'),
      body: root.querySelector('[data-dp-contact-preview-body]'),
    };

    function syncPayload() {
      if (payload.name && fields.name) payload.name.value = fields.name.value.trim();
      if (payload.email && fields.email) payload.email.value = fields.email.value.trim();
      if (payload.subject && fields.subject) payload.subject.value = fields.subject.value.trim();
      if (payload.body && fields.body) payload.body.value = fields.body.value.trim();
    }

    function showEditPanel() {
      confirmPanel.classList.add(PANEL_HIDDEN_CLASS);
      confirmPanel.hidden = true;
      editPanel.classList.remove(PANEL_HIDDEN_CLASS);
    }

    function showConfirmPanel() {
      editPanel.classList.add(PANEL_HIDDEN_CLASS);
      confirmPanel.classList.remove(PANEL_HIDDEN_CLASS);
      confirmPanel.hidden = false;
    }

    function fillPreview() {
      Object.keys(preview).forEach(function (key) {
        if (preview[key] && fields[key]) {
          preview[key].textContent = fields[key].value.trim();
        }
      });
    }

    confirmBtn.addEventListener('click', function () {
      if (!form.reportValidity()) return;
      syncPayload();
      fillPreview();
      showConfirmPanel();
      scrollContactToTop(root, 'smooth');
    });

    backBtn.addEventListener('click', function () {
      showEditPanel();
      scrollContactToTop(root, 'smooth');
    });

    form.addEventListener('submit', function () {
      syncPayload();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-dreampiece-contact]').forEach(initContact);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', function () {
    document.querySelectorAll('[data-dreampiece-contact]').forEach(function (root) {
      if (root.querySelector('[data-dp-contact-success]')) {
        scrollContactToTopAfterPaint(root);
      }
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.matches('[data-dreampiece-contact]')
      ? event.target
      : event.target.querySelector('[data-dreampiece-contact]');
    if (root) initContact(root);
  });
})();
